<div>
    <img [src]="{ light: 'assets/images/no-access.svg', dark: 'assets/images/no-access-dark.svg' } | themeVariant" />
    <h2>{{ "dtmUi.notAuthorizedMessage" | transloco }}</h2>
</div>
